<template>
  <div class="leaves">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Leaves</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Leaves</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a class="btn add-btn" @click="openDialog"
                  ><i class="fa fa-plus"></i> Request Leave</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!-- Leave Statistics -->
          <div class="row">
            <div class="col-md-3" v-for="item in leaveEgb" :key="item.typeId">
              <div class="stats-info">
                <h6>{{ item.leaveTypeName }} Leave</h6>
                <h4>{{ item.eligible - item.used }}</h4>
              </div>
            </div>
          </div>
          <!-- /Leave Statistics -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>Error!</strong> {{ error }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <v-data-table
                  :headers="headers"
                  :items="employeeLeaves"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.fromDate`]="{ item }">
                    {{
                      item.fromDate
                        ? new Date(item.fromDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.allow`]="{ item }">
                    <input
                      v-model="item.needAllowance"
                      readonly
                      disabled
                      type="checkbox"
                      v-if="!item.needAllowance == false"
                    />
                  </template>
                  <template v-slot:[`item.toDate`]="{ item }">
                    {{
                      item.toDate
                        ? new Date(item.toDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <div
                      class="dropdown dropdown-action"
                    >
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          @click="setEditLeave(item)"
                          v-if="item.status === 0"
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a class="dropdown-item" @click="onDownload(item)" v-if="(item.leaveTypeId === 1 || item.leaveTypeId === 2) && item.status === 1"
                          ><i class="fa fa-file-o m-r-5"></i> Download Certificate</a
                        >
                        <a class="dropdown-item" @click="setDeleteLeave(item)" v-if="item.status == 0"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                        <!-- <a
                          class="dropdown-item"
                          @click="setEditLeave(item)"
                          v-if="item.status == 1"
                          ><i class="fa fa-pencil m-r-5"></i> Download Certificate</a
                        > -->
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 && item.nextApproval"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting
                      Manager Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="!item.nextApproval && item.status == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting HR
                      Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2 && item.approvedByHOD"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
          <!-- /Page Content -->
          <!-- Add Leave Modal -->
          <v-dialog v-model="dialog" max-width="500px">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Leave</h5>
                <button type="button" @click="close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <form @submit.prevent="onSubmit">
                  <div class="form-group">
                    <label>Leave Type <span class="text-danger">*</span></label>
                    <select
                      class="form-control"
                      v-model="leaveTypeId"
                      @change="getRemainingLeaveDays"
                      @click.once="checkLeaveTypes"
                    >
                      <option>Select Leave Type</option>
                      <option
                        v-for="item in leaveData"
                        :key="item.typeId"
                        :value="item.typeId"
                      >
                        {{ item.leaveTypeName }}
                      </option>
                      <!-- <option
                        v-for="item in leaveEgb"
                        :key="item.typeId"
                        :value="item.typeId"
                        v-if="
                          item.leaveTypeName !== 'Annual' &&
                            item.used != item.eligible
                        "
                      >
                        {{ item.leaveTypeName }}
                      </option> -->
                    </select>
                  </div>
                  <div
                    class="form-group wrapper-class"
                    v-if="eligibileDays > 0"
                  >
                    <label>From <span class="text-danger">*</span></label>
                    <div class="cal-icon">
                      <datepicker
                        v-model="fromDate"
                        calendar-class
                        input-class
                        bootstrap-styling
                        class="form-control datetimepicker"
                        type="text"
                      />
                      <!-- <input class="form-control datetimepicker" type="text"> -->
                    </div>
                  </div>
                  <!-- 
                  <div class="form-group" v-if="eligibileDays > 0">
                    <label>Duration <span class="text-danger">*</span></label>

                    <div class="form-group">
                      <select
                        class="form-control"
                        v-model="leaveDays"
                        @change="calculateLeaveDays"
                      >
                        <option value="0">1 day</option>
                        <option value="1">2 days</option>
                        <option value="2">3 days</option>
                        <option value="3">4 days</option>
                        <option value="4">5 days</option>
                        <option value="5">6 days</option>
                        <option value="6">7 days</option>
                        <option value="7">8 days</option>
                        <option value="8">9 days</option>
                        <option value="9">10 days</option>
                        <option value="10">11 days</option>
                        <option value="11">12 days</option>
                        <option value="12">13 days</option>
                        <option value="13">14 days</option>
                        <option value="14">15 days</option>
                        <option value="15">16 days</option>
                        <option value="16">17 days</option>
                        <option value="17">18 days</option>
                        <option value="18">19 days</option>
                        <option value="19">20 days</option>
                        <option value="20">21 days</option>
                        <option value="21">22 days</option>
                        <option value="22">23 days</option>
                        <option value="23">24 days</option>
                        <option value="24">25 days</option>
                        <option value="25">26 days</option>
                        <option value="26">27 days</option>
                        <option value="27">28 days</option>
                        <option value="28">29 days</option>
                        <option value="29">30 days</option>
                        <option value="30">31 days</option>
                      </select>
                    </div>
                  </div> -->
                  <div class="form-group" v-if="eligibileDays > 0">
                    <label>To <span class="text-danger">*</span></label>
                    <div class="cal-icon">
                      <datepicker
                        v-model="toDate"
                        bootstrap-styling
                        class="form-control datetimepicker"
                        @closed="getNoOfDaysInterval()"
                        type="date"
                      />
                      <!-- <input class="form-control datetimepicker" type="text"> -->
                    </div>
                  </div>
                  <div class="form-group">
                    <label
                      >Remaining Leaves
                      <span class="text-danger">*</span></label
                    >
                    <input
                      :value="this.getRemainingDays()"
                      class="form-control"
                      readonly
                      type="text"
                    />
                  </div>
                  <div class="form-group" v-if="eligibileDays > 0">
                    <label
                      >Leave Reason <span class="text-danger">*</span></label
                    >
                    <textarea
                      v-model="reason"
                      rows="4"
                      class="form-control"
                    ></textarea>
                  </div>
                  <div
                    class="form-group"
                    v-if="eligibileDays > 0 && leaveTypeId == 1"
                  >
                    <div class="row" v-if="allowDallowance">
                      <div class="col-md-1">
                        <input
                          v-model="needAllowance"
                          class="form-control"
                          type="checkbox"
                        />
                      </div>
                      <div class="col-md-10">
                        <label>Need Allowance</label>
                      </div>
                    </div>
                  </div>
                  <div class="submit-section" v-if="eligibileDays > 0">
                    <button
                      class="btn btn-primary submit-btn"
                      :disabled="submitted"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </v-dialog>
          <!-- /Add Leave Modal -->

          <!-- Edit Leave Modal -->
          <v-dialog v-model="dialogEdit" max-width="500px">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Edit Leave</h5>
                <button type="button" @click="closeEdit">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="updateLeave">
                  <div class="row">
                    <div class="col-md-12">
                      <div
                        class="alert alert-danger alert-dismissible fade show"
                        role="alert"
                        v-if="error"
                      >
                        <strong>Error!</strong> {{ error }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        class="alert alert-success alert-dismissible fade show"
                        role="alert"
                        v-if="message"
                      >
                        <strong>Success!</strong> {{ message }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Leave Type <span class="text-danger">*</span></label>
                    <select
                      class="form-control"
                      v-model="leave.leaveTypeId"
                      @change="getRemainingLeaveDays"
                    >
                      <option>Select Leave Type</option>
                      <option
                        v-for="item in leaveTypes"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group wrapper-class">
                    <label>From <span class="text-danger">*</span></label>
                    <div class="cal-icon">
                      <datepicker
                        v-model="leave.fromDate"
                        calendar-class
                        input-class
                        bootstrap-styling
                        class="form-control datetimepicker"
                        type="text"
                      />
                      <!-- <input class="form-control datetimepicker" type="text"> -->
                    </div>
                  </div>

                  <div class="form-group">
                    <label>To <span class="text-danger">*</span></label>
                    <div class="cal-icon">
                      <datepicker
                        v-model="leave.toDate"
                        bootstrap-styling
                        class="form-control datetimepicker"
                        @closed="getNoOfDaysIntervalEdit()"
                        type="date"
                      />
                      <!-- <input class="form-control datetimepicker" type="text"> -->
                    </div>
                  </div>
                  <!-- <div class="form-group">
                    <label
                      >Number of days <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="leave.days"
                      class="form-control"
                      readonly
                      type="text"
                    />
                  </div> -->
                  <div class="form-group">
                    <label
                      >Remaining Leaves
                      <span class="text-danger">*</span></label
                    >
                    <input
                      :value="this.getRemainingDaysEdit()"
                      class="form-control"
                      readonly
                      type="text"
                    />
                  </div>
                  <div class="form-group">
                    <label
                      >Leave Reason <span class="text-danger">*</span></label
                    >
                    <textarea
                      v-model="leave.reason"
                      rows="4"
                      class="form-control"
                    ></textarea>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-1">
                        <input
                          v-model="leave.needAllowance"
                          class="form-control"
                          type="checkbox"
                        />
                      </div>
                      <div class="col-md-10">
                        <label>Need Allowance</label>
                      </div>
                    </div>
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </v-dialog>
          <!-- /Edit Leave Modal -->
          <!-- Delete Leave Modal -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                    @click="closeDelete"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h3>Delete Leave</h3>
                  <p>Are you sure want to delete this leave?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        class="btn btn-primary continue-btn"
                        @click="deleteLeave()"
                        data-dismiss="modal"
                        >Delete</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        href="javascript:void(0);"
                        data-dismiss="modal"
                        @click="closeDelete"
                        class="btn btn-primary cancel-btn"
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-dialog>
          <!-- /Delete Leave Modal -->
        </div>
        <!-- /Page Wrapper -->
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import Datepicker from "vuejs-datepicker";
import { organizationService } from "@/services/organizationService";
import { employeeService } from "@/services/employeeService";
import { authenticationService } from "@/services/authenticationService";
import moment from "moment";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogStatus: false,
      dialogDelete: false,
      submitted: false,
      media: "data:image/jpeg;base64,",
      headers: [
        { text: "LeaveType", value: "leaveType.name" },
        { text: "From", value: "fromDate" },
        { text: "To", value: "toDate" },
        { text: "No of Days", value: "days" },
        { text: "Need Allowance", value: "allow" },
        { text: "Reason", value: "reason" },
        { text: "Status", value: "stat" },
        { text: "Action", value: "actions", sortable: false }
      ],
      leaveTypeId: 0,
      days: 0,
      leaveDays: "",
      needAllowance: false,
      allowDallowance: false,
      leave: {},
      employeeLeaves: [],
      employeeLeave: {},
      leaves: [],
      leaveTypes: [],
      fromDate: "",
      toDate: "",
      eligibileDays: 0,
      reason: "",
      employeeId: 0,
      employees: [],
      employee: {},
      leaveEgb: [],
      leaveData: [],
      company: authenticationService.currentOfficeValue,
      user: authenticationService.currentUserValue,
      error: "",
      message: "",
      daysInterval: "",
      status: ""
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    },
    dialogStatus(val) {
      val || this.closeEdit();
    }
  },

  methods: {
    // calculateLeaveDays() {
    //   let day = Number(this.leaveDays);
    //   let newDate = new Date(
    //     moment(this.fromDate, "days") + day * 24 * 60 * 60 * 1000
    //   );
    //   this.toDate = newDate;
    // },

    checkLeaveTypes() {
      this.leaveEgb.filter(c => {
        if (c.leaveTypeName == "Annual" && c.used != c.eligible) {
          console.log(c);
          return this.leaveData.push(c);
        } else if (c.leaveTypeName != "Annual" && c.used != c.eligible) {
          console.log(c);
          return this.leaveData.push(c);
        }
      });
    },

    clearModel() {
      this.employeeId = "";
      this.reason = "";
      this.daysInterval = "";
      this.leaveDays = "";
      this.toDate = "";
      this.eligibileDays = 0;
      this.fromDate = "";
      this.leaveTypeId = 0;
      this.submitted = false;
      this.error = "";
      this.message = "";
    },

    close() {
      this.dialog = false;
      this.clearModel();
    },

    openDialog() {
      this.dialog = true;
    },

    closeEdit() {
      this.dialogEdit = false;
    },

    closeStatus() {
      this.dialogStatus = false;
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    setEditLeave(item) {
      this.leave = item;
      this.getRemainingLeaveDaysByType(this.leave.leaveTypeId);
      this.dialogEdit = true;
      // console.log(`item`, item)
    },

    setLeaveStatus(item) {
      this.leave = item;
      this.dialogStatus = true;
      // console.log(`item`, item)
    },

    setDeleteLeave(item) {
      this.leave = item;
      this.dialogDelete = true;
    },
    getRemainingLeaveDays() {
      employeeService
        .getEmployeeLeaveEligibility(this.user.employee.id, this.leaveTypeId)
        .then(o => {
          this.eligibileDays = o;
          console.log(o);
        });
    },
    getRemainingLeaveDaysByType(leaveTypeId) {
      employeeService
        .getEmployeeLeaveEligibility(this.user.employee.id, leaveTypeId)
        .then(o => {
          this.eligibileDays = o;
        });
    },
    getPrevAllowanceLeaves() {
      employeeService
        .getPrevAllowanceLeaves(this.user.employee.id)
        .then(o => {
          this.allowDallowance = o == 0;
        });
    },
    getSummary() {
      employeeService.getEmployeeLeaveSummary(this.user.employee.id).then(
        model => {
          var Mindex = model.findIndex(
            c => c.leaveTypeName.toUpperCase() == "MATERNITY"
          );
          var Pindex = model.findIndex(
            c => c.leaveTypeName.toUpperCase() == "PATERNITY"
          );

          if (Mindex > -1) {
            var g = this.user.employee.gender.toUpperCase();
            if (g == "MALE") model.splice(Mindex, 1);
          }

          if (Pindex > -1) {
            var g = this.user.employee.gender.toUpperCase();
            if (g == "FEMALE") model.splice(Pindex, 1);
          }

          this.leaveEgb = model.filter(x => x.eligible != 0);
        },
        error => {
          error = error;
        }
      );
    },
    deleteLeave() {
      // const id = this.employeeLeaves.id;
      console.log(this.leave.id);
      employeeService.removeEmployeeLeave(this.leave.id).then(
        id => {
          employeeService
            .getEmployeeLeavesByEmployee(this.user.employee.id)
            .then(o => {
              this.employeeLeaves = o;
            });
          this.dialogDelete = false;
        },
        e => {
          this.error = "Leave Type is being used in some information";
        }
      );
    },
    setLeave(item) {
      this.employeeLeave = item;
    },
    updateLeave() {
      this.submitted = true;
      const id = this.leave.id;
      this.loading = true;
      employeeService.updateEmployeeLeave(id, this.leave).then(
        id => {
          employeeService
            .getEmployeeLeavesByEmployee(this.user.employee.id)
            .then(o => {
              this.employeeLeaves = o;
              this.closeEdit();
            });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    changeLeaveStatus(status) {
      this.submitted = true;
      const id = this.leave.id;
      this.leave.status = status;
      this.leave.approvedBy = this.user.employee.id;
      this.loading = true;
      employeeService.updateEmployeeLeave(id, this.leave).then(
        id => {
          employeeService.getEmployeeLeaves(this.company.id).then(o => {
            this.employeeLeaves = o;
            this.closeStatus();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    getEmployeeLeaves() {
      employeeService.getEmployeeLeavesByEmployee(this.user.employee.id).then(
        model => {
          this.employeeLeaves = model;
          // console.log("leaves:", model[0]);
        },
        error => {
          error = error;
        }
      );
    },
    getEmployees() {
      employeeService.getEmployees(this.company.id).then(
        model => {
          this.employees = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getLeaveTypes() {
      organizationService.getLeaveTypes().then(
        model => {
          var Mindex = model.findIndex(
            c => c.name.toUpperCase() == "MATERNITY"
          );
          var Pindex = model.findIndex(
            c => c.name.toUpperCase() == "PATERNITY"
          );

          if (Mindex > -1) {
            var g = this.user.employee.gender.toUpperCase();
            if (g == "MALE") model.splice(Mindex, 1);
          }

          if (Pindex > -1) {
            var g = this.user.employee.gender.toUpperCase();
            if (g == "FEMALE") model.splice(Pindex, 1);
          }

          this.leaveTypes = model;
          console.log(model, );
        },
        error => {
          error = error;
        }
      );
    },
    getNoOfDaysInterval() {
      if (this.toDate == "" || this.fromDate == "") {
        this.days = 0;
      }
      const startDate = new Date(this.fromDate);
      const endDate = new Date(this.toDate);
      let count = 0;
      const curDate = new Date(startDate.getTime());
      while (curDate <= endDate) {
        const dayOfWeek = curDate.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) count++;
        curDate.setDate(curDate.getDate() + 1);
      }
      this.days = count;
    },
    getNoOfDaysIntervalEdit() {
      const startDate = new Date(this.leave.fromDate);
      const endDate = new Date(this.leave.toDate);
      let count = 0;
      const curDate = new Date(startDate.getTime());
      while (curDate <= endDate) {
        const dayOfWeek = curDate.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) count++;
        curDate.setDate(curDate.getDate() + 1);
      }
      this.leave.days = count;
    },
    getRemainingDays() {
      if (this.toDate == "" || this.fromDate == "") {
        return this.eligibileDays;
      }
      const startDate = new Date(this.fromDate);
      const endDate = new Date(this.toDate);
      let count = 0;
      const curDate = new Date(startDate.getTime());
      while (curDate <= endDate) {
        const dayOfWeek = curDate.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) count++;
        curDate.setDate(curDate.getDate() + 1);
      }
      return this.eligibileDays - count;
    },
    getRemainingDaysEdit() {
      const startDate = new Date(this.leave.fromDate);
      const endDate = new Date(this.leave.toDate);
      let count = 0;
      const curDate = new Date(startDate.getTime());
      while (curDate <= endDate) {
        const dayOfWeek = curDate.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) count++;
        curDate.setDate(curDate.getDate() + 1);
      }
      return this.eligibileDays - count;
    },
    onDownload(leave) {
      this.loading = true
      employeeService.exportCertificate(leave.id, leave.leaveTypeId)
      .then(response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
          this.loading = false;
        }).catch((error) => {
            alert(error);
            this.loading = false;
        });
    },
    // setLeaveType() {
    //   this.leaveType = this.leaveTypes.map((a) => a);
    //   //console.log(this.leaveType)
    // },
    onSubmit() {
      this.submitted = true;
      // stop here if form is invalid
      // this.$v.$touch();
      if (this.getRemainingDays() < 0) {
        this.error =
          "Your remaining  leave days is not enoungh for the days you want";
        console.log("na bddb");
        return;
      }
      if (this.reason == "") {
        return (this.error = "Enter leave reason!");
      }
      this.loading = true;
      employeeService
        .addEmployeeLeave(
          this.company.id,
          this.user.employee.id,
          this.fromDate,
          this.toDate,
          this.days,
          this.reason,
          this.leaveTypeId,
          0,
          0,
          this.needAllowance
        )
        .then(
          id => {
            this.message = "New Leave Added successfully";
            employeeService
              .getEmployeeLeavesByEmployee(this.user.employee.id)
              .then(
                model => {
                  this.close();
                  this.employeeLeaves = model;
                  // console.log(model[0]);
                  this.message = "";
                  this.error = "";
                }
                // error => { error = error }
              );
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    }
  },
  mounted() {
    this.getLeaveTypes();
    this.getSummary();
    this.getPrevAllowanceLeaves();
    this.getEmployeeLeaves();

    //this.setDaysInterval()
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // Datatable

    // if ($('.datatable').length > 0) {
    //   $('.datatable').DataTable({
    //     "bFilter": false,
    //   });
    // }
    // if ($('.floating').length > 0) {
    //   $('.floating').on('focus blur', function (e) {
    //     $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
    //   }).trigger('blur');
    // }
  },
  name: "leaves"
};
</script>



// WEBPACK FOOTER //
// src/components/leaves/leaveRequest.vue